module.exports = __webpack_public_path__ + "img/onlineConsult.66fc25fb.png";